import React, { useEffect, useRef, useState } from 'react';
import FilterSelect from "../../FilterSelect/FilterSelect";
import {
    dropdownAction,
    filterCoachesOptionsAction,
    filterDateAction,
    filterMinSumAction,
    filterMaxSumAction,
    filterPaymentMethodsOptionsAction,
    filterAdminsOptionsAction,
    filterSubjectOptionsAction,
    filterTypesOptionsAction,
    filterUserAction,
    filterWindowAction,
    resetAllFiltersAction
} from "../../../redux/rootReducer";
import {
    getSalesSagaAction,
    getUsersForSubscriptionSagaAction,
    exportSalesToExcelSagaAction
} from "../../../redux/sagaActions";
import { useDispatch, useSelector } from "react-redux";
import FiltersWrapper from "../../FiltersWrapper/FiltersWrapper";
import CalendarOffline from "../../CalendarOffline/CalendarOffline";

const SalesHeader = () => {
    const dispatch = useDispatch();

    const filterDate = useSelector(state => state.filterDate);
    const filterUser = useSelector(state => state.filterUser);
    const dropdown = useSelector(state => state.dropdown);
    const subscription_types = useSelector(state => state.subscription_types);
    const subscription_coaches = useSelector(state => state.subscription_coaches);
    const payment_methods = useSelector(state => state.payment_methods);
    const admins = useSelector(state => state.admins);

    const filterTypesOptions = useSelector(state => state.filterTypesOptions);
    const filterCoachesOptions = useSelector(state => state.filterCoachesOptions);
    const filterSubjectOptions = useSelector(state => state.filterSubjectOptions);
    const filterPaymentMethodsOptions = useSelector(state => state.filterPaymentMethodsOptions);
    const filterAdminsOptions = useSelector(state => state.filterAdminsOptions);
    const filterMinSum = useSelector(state => state.filterMinSum);
    const filterMaxSum = useSelector(state => state.filterMaxSum);

    // Состояние раскрытых фильтров
    const [allFilters, setAllFilters] = useState(false);

    // Состояние календаря
    const [openFromCalendar, setOpenFromCalendar] = useState(false);
    const [openToCalendar, setOpenToCalendar] = useState(false);

    // Таймер для отсрочки запроса посетителей на сервере
    const timer = useRef(0);

    const getUsers = text => {

        if (timer.current) clearTimeout(timer.current);

        if (!text.trim()) {
            dispatch(filterUserAction({
                user: { id: '', name: '' },
                users: []
            }));
            return false;
        }

        // Делаем задержку для набора текста
        timer.current = setTimeout(() => {
            dispatch(getUsersForSubscriptionSagaAction({ text, type: 'filter' }));
        }, 500);
    };

    useEffect(() => {
        dispatch(filterTypesOptionsAction(subscription_types.map(elem => ({ ...elem, active: false }) )));
        dispatch(filterCoachesOptionsAction(subscription_coaches.filter(el => el.id).map(elem => ({ ...elem, active: false }) )));
        dispatch(filterPaymentMethodsOptionsAction(payment_methods.map(elem => ({ ...elem, active: false }))));
        dispatch(filterAdminsOptionsAction(admins.map(elem => ({ ...elem, active: false }))));
    }, [subscription_types, subscription_coaches, payment_methods]);

    return (
        <>
            <FiltersWrapper>
                <div className="flt__content">
                    <div className="flt__reset" onClick={ () => {
                        // Сброс фильтров
                        dispatch(resetAllFiltersAction());
                    } }>Сбросить фильтры</div>
                    <div className="flt__caption">Фильтры</div>
                    <div className="filter filter--calendar"
                         onClick={ event => {
                             event.preventDefault();
                             event.stopPropagation();
                             setOpenFromCalendar(!openFromCalendar);
                         } }
                    >
                        { `${ filterDate.from ? new Date(filterDate.from).toLocaleDateString('ru-Ru') : 'Дата с' }` }
                        {
                            filterDate.from
                                ? <div className="filter__remove" onClick={ event => {
                                    event.stopPropagation();
                                    dispatch(filterDateAction({ ...filterDate, from: '' }));
                                } } />
                                : false
                        }
                    </div>
                    <CalendarOffline
                        style={{ marginTop: 0 }}
                        date={ filterDate.from }
                        handler={ date => {
                            dispatch(filterDateAction({ ...filterDate, from: date }));
                            setOpenFromCalendar(false);
                        }}
                        open={ openFromCalendar }
                        close={ () => setOpenFromCalendar(false) }
                    />
                    <div className="filter filter--calendar"
                         onClick={ event => {
                             event.preventDefault();
                             event.stopPropagation();
                             setOpenToCalendar(!openToCalendar);
                         } }
                    >
                        { `${ filterDate.to ? new Date(filterDate.to).toLocaleDateString('ru-Ru') : 'Дата по' }` }
                        {
                            filterDate.to
                                ? <div className="filter__remove" onClick={ event => {
                                    event.stopPropagation();
                                    dispatch(filterDateAction({ ...filterDate, to: '' }));
                                } } />
                                : false
                        }
                    </div>
                    <CalendarOffline
                        style={{ marginTop: 0 }}
                        date={ filterDate.to }
                        handler={ date => {
                            dispatch(filterDateAction({ ...filterDate, to: date }));
                            setOpenToCalendar(false);
                        }}
                        open={ openToCalendar }
                        close={ () => setOpenToCalendar(false) }
                    />
                    <div className="select__wrapper">
                        <FilterSelect
                            options={ filterTypesOptions }
                            handler={ id => dispatch(filterTypesOptionsAction(filterTypesOptions.map(elem => {
                                // Меняем состояние выбранных элементов
                                if (elem.id === id) return { ...elem, active: !elem.active };
                                else return elem;
                            }))) }
                            placeholder={ 'Тип абонемента' }
                            open={ dropdown === 'filter_types' }
                            openHandler={ () => dispatch(dropdownAction('filter_types')) }
                            clear={ () => dispatch(filterTypesOptionsAction(filterTypesOptions.map(elem => {

                                if (elem.active) return { ...elem, active: !elem.active };
                                else return elem;
                            }))) }
                        />
                    </div>
                    <div className="select__wrapper">
                        <FilterSelect
                            options={ filterCoachesOptions }
                            handler={ id => dispatch(filterCoachesOptionsAction(filterCoachesOptions.map(elem => {
                                // Меняем состояние выбранных элементов
                                if (elem.id === id) return { ...elem, active: !elem.active };
                                else return elem;
                            }))) }
                            placeholder={ 'Тренер' }
                            open={ dropdown === 'filter_coaches' }
                            openHandler={ () => dispatch(dropdownAction('filter_coaches')) }
                            clear={ () => dispatch(filterCoachesOptionsAction(filterCoachesOptions.map(elem => {

                                if (elem.active) return { ...elem, active: !elem.active };
                                else return elem;
                            }))) }
                        />
                    </div>
                    <div className="select__wrapper">
                        <FilterSelect
                            options={ filterSubjectOptions }
                            handler={ id => dispatch(filterSubjectOptionsAction(filterSubjectOptions.map(elem => {
                                // Меняем состояние выбранных элементов
                                if (elem.id === id) return { ...elem, active: !elem.active };
                                else return elem;
                            }))) }
                            placeholder={ 'Платежи за' }
                            open={ dropdown === 'filter_sales_type' }
                            openHandler={ () => dispatch(dropdownAction('filter_sales_type')) }
                            clear={ () => dispatch(filterSubjectOptionsAction(filterSubjectOptions.map(elem => {

                                if (elem.active) return { ...elem, active: !elem.active };
                                else return elem;
                            }))) }
                        />
                    </div>
                    <div className="select__wrapper">
                        <FilterSelect
                            options={ filterPaymentMethodsOptions }
                            handler={ id => dispatch(filterPaymentMethodsOptionsAction(filterPaymentMethodsOptions.map(elem => {
                                // Меняем состояние выбранных элементов
                                if (elem.id === id) return { ...elem, active: !elem.active };
                                else return elem;
                            }))) }
                            placeholder={ 'Метод оплаты' }
                            open={ dropdown === 'filter_payment_method' }
                            openHandler={ () => dispatch(dropdownAction('filter_payment_method')) }
                            clear={ () => dispatch(filterPaymentMethodsOptionsAction(filterPaymentMethodsOptions.map(elem => {

                                if (elem.active) return { ...elem, active: !elem.active };
                                else return elem;
                            }))) }
                        />
                    </div>
                    <div className="select__wrapper">
                        <FilterSelect
                            options={ filterAdminsOptions }
                            handler={ id => dispatch(filterAdminsOptionsAction(filterAdminsOptions.map(elem => {
                                // Меняем состояние выбранных элементов
                                if (elem.id === id) return { ...elem, active: !elem.active };
                                else return elem;
                            }))) }
                            placeholder={ 'Администратор' }
                            open={ dropdown === 'filter_admins' }
                            openHandler={ () => dispatch(dropdownAction('filter_admins')) }
                            clear={ () => dispatch(filterAdminsOptionsAction(filterAdminsOptions.map(elem => {

                                if (elem.active) return { ...elem, active: !elem.active };
                                else return elem;
                            }))) }
                        />
                    </div>
                    <div className="filter filter--input">
                        <input type="text" className="filter__input"
                               placeholder={ 'Сумма платежа от' }
                               value={ filterMinSum }
                               onInput={ event => dispatch(filterMinSumAction(event.target.value)) }
                        />
                    </div>
                    <div className="filter filter--input">
                        <input type="text" className="filter__input"
                               placeholder={ 'Сумма платежа до' }
                               value={ filterMaxSum }
                               onInput={ event => dispatch(filterMaxSumAction(event.target.value)) }
                        />
                    </div>
                    <div className="dropdown">
                        <div className="filter filter--input">
                            <input className="filter__input"
                                   placeholder={ 'Посетитель' }
                                   value={ filterUser.user.name }
                                   onInput={ event => {
                                       dispatch(filterUserAction({
                                           ...filterUser,
                                           user: {
                                               id: '',
                                               name: event.target.value
                                           }
                                       }));
                                       // Получение с сервера списка всех пользователей, с совпадением по email или телефону
                                       getUsers(event.target.value);
                                   } }
                            />
                            {
                                filterUser.user.id || filterUser.user.name
                                    ? <div className="filter__remove" onClick={ event => {
                                        event.stopPropagation();
                                        dispatch(filterUserAction({ ...filterUser, user: { id: '', name: '' } }));
                                    } } />
                                    : false
                            }
                        </div>
                        <div className={ `dropdown__items ${ dropdown === 'filter_user' ? 'dropdown__items--open' : '' }` }>
                            {
                                filterUser.users.map(elem => {
                                    return (
                                        <div className="dropdown__item" key={ elem.id }
                                             onClick={ () => {
                                                 dispatch(filterUserAction({
                                                     ...filterUser,
                                                     user: { id: elem.id, name: elem.name }
                                                 }));
                                                 dispatch(dropdownAction(null));
                                             } }
                                        >{ `${ elem.name } ${ elem.phone }` }</div>
                                    );
                                })
                            }
                        </div>
                    </div>
                    <div className="button button--blue"
                         onClick={ () => {
                             // Закрываем фильтры
                             dispatch(filterWindowAction(false));

                             // Если раскрыты фильтры, закрываем их
                             if (allFilters) {
                                 setAllFilters(false);
                             }

                             dispatch(getSalesSagaAction({
                                 page: 1,
                                 from: filterDate.from,
                                 to: filterDate.to,
                                 subscription_type: JSON.stringify(filterTypesOptions.filter(el => el.active).map(el => el.id)),
                                 subscription_coach: JSON.stringify(filterCoachesOptions.filter(el => el.active).map(el => el.id)),
                                 sales_type: JSON.stringify(filterSubjectOptions.filter(el => el.active).map(el => el.id)),
                                 payment_methods: JSON.stringify(filterPaymentMethodsOptions.filter(el => el.active).map(el => el.id)),
                                 admins: JSON.stringify(filterAdminsOptions.filter(el => el.active).map(el => el.id)),
                                 minSum: filterMinSum,
                                 maxSum: filterMaxSum,
                                 sales_user: filterUser.user.id
                             }));
                         } }
                    >Применить</div>
                    {
                        filterDate.from && filterDate.to
                            ?
                            <div className="button button--yellow"
                                 onClick={ () => {
                                     // Закрываем фильтры
                                     dispatch(filterWindowAction(false));

                                     dispatch(exportSalesToExcelSagaAction({
                                         from: filterDate.from,
                                         to: filterDate.to,
                                         subscription_type: JSON.stringify(filterTypesOptions.filter(el => el.active).map(el => el.id)),
                                         subscription_coach: JSON.stringify(filterCoachesOptions.filter(el => el.active).map(el => el.id)),
                                         sales_type: JSON.stringify(filterSubjectOptions.filter(el => el.active).map(el => el.id)),
                                         payment_methods: JSON.stringify(filterPaymentMethodsOptions.filter(el => el.active).map(el => el.id)),
                                         minSum: filterMinSum,
                                         maxSum: filterMaxSum,
                                         sales_user: filterUser.user.id
                                     }));
                                 } }
                            >Сформировать отчёт</div>
                            : false
                    }
                </div>
            </FiltersWrapper>
        </>
    );
};

export default SalesHeader;